import { render, staticRenderFns } from "./WarrantyTemplate.vue?vue&type=template&id=37c20922&scoped=true"
import script from "./WarrantyTemplate.vue?vue&type=script&lang=js"
export * from "./WarrantyTemplate.vue?vue&type=script&lang=js"
import style0 from "./WarrantyTemplate.vue?vue&type=style&index=0&id=37c20922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c20922",
  null
  
)

export default component.exports